export const btnConfig =[
    {label:'reject' ,value:false},
    {label:'accept' ,value:true},
]